/** @format */

import {Trans, useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {ColumnType} from 'components/Table/core/types';

import ResolvedCell, {ResolvedCellData} from '../components/ResolvedCell';

const ProjectsCell = ({count}: {count: number}) => {
  const {t} = useTranslation();
  return <Typography>{t('plurals.companies', {count})}</Typography>;
};

const Empty = () => <Box />;

export const staffColumns: ColumnType[] = [
  {
    id: 'staff',
    title: <Trans>Сотрудник</Trans>,
    size: 250,
    sortingFn: 'text',
    order: 0,
    cell: info => {
      const value = String(info.getValue() ?? '');
      if (info.row.depth > 0) {
        return <Typography>{value}</Typography>;
      }
      return <Typography>{value || <Trans>Главный аккаунт</Trans>}</Typography>;
    },
  },
  {
    id: 'projects',
    title: <Trans>Проекты</Trans>,
    size: 250,
    sortingFn: 'alphanumeric',
    order: 10,
    cell: info =>
      info.row.depth > 0 ? <Empty /> : <ProjectsCell count={Number(info.getValue() ?? 0)} />,
  },
  {
    id: 'downloads',
    title: <Trans>Загрузки отчетов</Trans>,
    size: 250,
    sortingFn: 'alphanumeric',
    order: 20,
    cell: info => (
      <ResolvedCell
        {...(info.row.original as unknown as {downloadsCell: ResolvedCellData}).downloadsCell}
      />
    ),
  },
  {
    id: 'directClicks',
    title: <Trans>Клики на ссылки перехода в кабинет</Trans>,
    size: 250,
    sortingFn: 'alphanumeric',
    order: 30,
    cell: info => (
      <ResolvedCell
        {...(info.row.original as unknown as {directClicksCell: ResolvedCellData}).directClicksCell}
      />
    ),
  },
  {
    id: 'pageOpens',
    title: <Trans>Заходы на страницы сенсоров</Trans>,
    size: 250,
    sortingFn: 'alphanumeric',
    order: 40,
    cell: info => (
      <ResolvedCell
        {...(info.row.original as unknown as {pageOpensCell: ResolvedCellData}).pageOpensCell}
      />
    ),
  },
];
